import {
  MolsonBox,
  MolsonQuantityButton,
  MolsonTextField
} from '@components/reusable'
import {
  type InputBaseProps,
  type SxProps,
  type Theme,
  useMediaQuery
} from '@mui/material'
import { molsonTheme } from '@/theme'

export type QuantityControlProps = {
  displayType: 'icon' | 'text'
  isDecreaseDisabled?: boolean
  isIncreaseDisabled?: boolean
  onDecrease: () => void
  onIncrease: () => void
  quantity?: number
  sx?: SxProps<Theme>
  inputProps?: InputBaseProps['inputProps']
  shouldMinifySize?: boolean
}

export const MolsonQuantityControl = ({
  displayType,
  isDecreaseDisabled,
  isIncreaseDisabled,
  onDecrease,
  onIncrease,
  quantity,
  sx,
  inputProps,
  shouldMinifySize = false
}: QuantityControlProps) => {
  const matchesSmUp = useMediaQuery((theme: typeof molsonTheme) =>
    theme.breakpoints.up('sm')
  )
  const matchesLgDown = useMediaQuery((theme: typeof molsonTheme) =>
    theme.breakpoints.down('lg')
  )

  const isScreenSizeInRange = matchesSmUp && matchesLgDown && shouldMinifySize
  const btnSize = isScreenSizeInRange ? 'small' : 'regular'

  return (
    <MolsonBox sx={{ alignItems: 'center', display: 'flex', gap: 1, ...sx }}>
      <MolsonQuantityButton
        displayType={displayType}
        isDisabled={isDecreaseDisabled || quantity === 1}
        onClick={onDecrease}
        type="decrease"
        btnSize={btnSize}
      />
      {!!quantity && (
        <MolsonTextField
          InputProps={{
            style: {
              height: isScreenSizeInRange ? 35 : 42,
              width: isScreenSizeInRange ? 35 : 42
            }
          }}
          inputProps={{
            style: {
              padding: 0,
              textAlign: 'center',
              ...inputProps?.style
            }
          }}
          disabled={true}
          value={quantity}
        />
      )}
      <MolsonQuantityButton
        displayType={displayType}
        isDisabled={isIncreaseDisabled}
        onClick={onIncrease}
        type="increase"
        btnSize={btnSize}
      />
    </MolsonBox>
  )
}
